module.exports = __webpack_public_path__ + "img/loads-4.cd51e440.jpeg";